import React from 'react';
import Input from '../../../../../Core/Fields/Floating/Input';
import GetIcon from '../../../../../utils/Icon';

function Tab2({ genaralData }) {
  const formatAddress = (address) => {
    if (!address) return '';
    return address.replace(/<br>/g, '\n').replace(/<\/?[^>]+(>|$)/g, '');
  };

  return (
    <div className="row m-0" style={{ padding: "8px", borderRadius: "5px" }}>
      <div className="col-12">
        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>Billing Address</p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>

      <div className="col-md-4 mt-0">
        <Input
          id="billingAddress"
          label="Billing Address"
          value={formatAddress(genaralData?.address_display || '')}
          readOnly
          style={{ fontSize: '0.8rem', height: '30px' }}
        />
      </div>

      <div className="col-md-4 mt-0">
        <Input
          id="contactPhone"
          label="Customer Contact"
          value={genaralData?.contact_phone || genaralData?.contact_mobile || 'N/A'}
          readOnly
          style={{ fontSize: '0.8rem', height: '30px' }}
        />
      </div>

      <div className="col-md-4 mt-0">
        <Input
          id="gstCategory"
          label="GST Category"
          value={genaralData?.gst_category || 'N/A'}
          readOnly
          style={{ fontSize: '0.8rem', height: '30px' }}
        />
      </div>

      <div className="col-12 mt-2">
        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>Shipping Address</p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>

      <div className="col-md-4 mt-0">
        <Input
          id="shippingAddress"
          label="Shipping Address"
          value={formatAddress(genaralData?.shipping_address || '')}
          readOnly
          style={{ fontSize: '0.8rem', height: '30px' }}
        />
      </div>

      <div className="col-md-4 mt-0 mb-5">
        <Input
          id="territory"
          label="Territory"
          value={genaralData?.territory || 'N/A'}
          readOnly
          style={{ fontSize: '0.8rem', height: '30px' }}
        />
      </div>
    </div>
  );
}

export default Tab2;
